(function () {
  "use strict";

  angular
    .module("trainerWebApp.directives")
    .directive("mfCreateNewGroup", mfCreateNewGroup);

  function mfCreateNewGroup() {
    return {
      restrict: "A",
      link: function ($scope, elem, attrs) {

        var usersAndGroupsSelect = $("#inputUsersGroupsMultiple");
        var trainersSelect = $("#inputTrainerManagers");

        var usersAndGroupsOpts = $scope.selectUsersAndGroupsOptions;
        var trainersOpts = $scope.selectTrainersOptions;

        usersAndGroupsOpts.formatResult = function (object, container, query) {
          if (object.children) {
            container[0].innerHTML = '<span>' + object.text + '</span>';
            return;
          }


          var term = $.trim(query.term || "");
          var html = '<div title="' + object.text + '" >';

          if (object.label && !object.hideLabelInDropDown)
            html = html + '<span>' + object.label + ': </span>';
          var startOfCriteriaInResult = object.text.toLowerCase().indexOf(term.toLowerCase());


          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + object.text.substr(0, startOfCriteriaInResult) + '</span>';
          else
            startOfCriteriaInResult = 0;

          html = html + '<span class="select2-match">' + object.text.substr(startOfCriteriaInResult, term.length) + '</span>';
          if (object.text.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + object.text.substr(startOfRestOfResult, object.text.length - startOfRestOfResult) + '</span>';
          }

          html = html + '</div>';
          container[0].innerHTML = html;
        };

        trainersOpts.formatResult = function (object, container, query) {
          if (object.children) {
            container[0].innerHTML = '<span>' + object.text + '</span>';
            return;
          }


          var term = $.trim(query.term || "");
          var html = '<div title="' + object.text + '" >';

          if (object.label && !object.hideLabelInDropDown)
            html = html + '<span>' + object.label + ': </span>';
          var startOfCriteriaInResult = object.name.toLowerCase().indexOf(term.toLowerCase());


          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + object.name.substr(0, startOfCriteriaInResult) + '</span>';
          else
            startOfCriteriaInResult = 0;

          html = html + '<span class="select2-match">' + object.name.substr(startOfCriteriaInResult, term.length) + '</span>';
          if (object.name.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + object.name.substr(startOfRestOfResult, object.name.length - startOfRestOfResult) + '</span>';
          }

          html = html + '</div>';
          container[0].innerHTML = html;
        };

        usersAndGroupsSelect.select2(usersAndGroupsOpts);
        trainersSelect.select2(trainersOpts);

        usersAndGroupsSelect.on("select2-selecting", function (event) {
          $scope.$apply(function () {
            $scope.addUserOrGroup(event.object, function (reopen) {
              clearUsersAndGroupsSelect(usersAndGroupsSelect, reopen);
            });
          });

          event.preventDefault();
        });

        trainersSelect.on("select2-selecting", function (event) {
          $scope.$apply(function () {
            $scope.addTrainer(event.object);
          });
          clearUsersAndGroupsSelect(trainersSelect, false);
          event.preventDefault();
        });

        function clearUsersAndGroupsSelect(select, reopen) {
          var searchInput = select.find('.select2-input');
          select.select2('close');
          searchInput.val('');
          searchInput.removeClass("select2-default");
          if (reopen) {
            select.select2('open');
          }
        }

        usersAndGroupsSelect.on("select2-open", function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
        });

        trainersSelect.on("select2-open", function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
        });

        $scope.forceCloseDropDown = function () {
          usersAndGroupsSelect.select2('close');
          trainersSelect.select2('close');
        };

        $scope.$on('$destroy', function () {
          $scope.forceCloseDropDown();
        });

      }
    }
  }

})();
